// /forgot-password
import { API } from "../../apiSlice";

export const checkEmailApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    checkEmail: builder.mutation<any, any>({
      query: (data) => {
        return {
          url: "users/check-email",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useCheckEmailMutation } = checkEmailApiSlice;
